module.exports = __webpack_public_path__ + "static/media/asset.6460801b.jpg";